var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMUserWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.307 18.9195C20.3614 18.9267 20.4159 18.9341 20.4703 18.9417L20.7438 18.9801C21.9346 19.1472 23 18.2396 23 17.058V16.1562C23 15.3112 22.4592 14.5573 21.649 14.2731C20.7129 13.9447 19.7466 13.7309 18.7711 13.6317C19.789 14.3676 20.4203 15.5593 20.4203 16.8594V17.979C20.4203 18.3042 20.3809 18.619 20.307 18.9195ZM16.1812 12.432C16.5868 12.5995 17.0324 12.6921 17.5 12.6921C19.3813 12.6921 20.9064 11.194 20.9064 9.34603C20.9064 7.49807 19.3813 6 17.5 6C17.4443 6 17.3889 6.00131 17.3338 6.00391C17.6759 6.73253 17.8671 7.54606 17.8671 8.40426C17.8671 9.98076 17.2219 11.4066 16.1812 12.432Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.07387 18.9195C4.01942 18.9267 3.96499 18.9341 3.91058 18.9417L3.63707 18.9801C2.44625 19.1472 1.38084 18.2396 1.38084 17.058V16.1562C1.38084 15.3112 1.92166 14.5573 2.73185 14.2731C3.66791 13.9447 4.63427 13.7309 5.60979 13.6317C4.59191 14.3676 3.96057 15.5593 3.96057 16.8594V17.979C3.96057 18.3042 3.99992 18.619 4.07387 18.9195ZM8.19971 12.432C7.79406 12.5995 7.34845 12.6921 6.88084 12.6921C4.99952 12.6921 3.47442 11.194 3.47442 9.34603C3.47442 7.49807 4.99952 6 6.88084 6C6.93657 6 6.992 6.00131 7.04707 6.00391C6.70496 6.73253 6.51377 7.54606 6.51377 8.40426C6.51377 9.98076 7.15896 11.4066 8.19971 12.432Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3671 8.40426C16.3671 6.10992 14.5071 4.25 12.2128 4.25C9.91848 4.25 8.05856 6.10992 8.05856 8.40426C8.05856 10.6986 9.91848 12.5585 12.2128 12.5585C14.5071 12.5585 16.3671 10.6986 16.3671 8.40426Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.15298 14.5215C10.425 13.3529 14.0006 13.3529 17.2727 14.5215C18.2607 14.8743 18.9203 15.8103 18.9203 16.8594V17.979C18.9203 19.446 17.621 20.5729 16.1687 20.3654L15.8351 20.3178C13.4325 19.9745 10.9932 19.9745 8.59049 20.3178L8.25693 20.3654C6.80468 20.5729 5.50537 19.446 5.50537 17.979V16.8594C5.50537 15.8103 6.16492 14.8743 7.15298 14.5215Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMUserWhite);
export default __webpack_public_path__ + "static/media/MUserWhite.02b29e928e20777f353878ea714d8a71.svg";
export { ForwardRef as ReactComponent };